export const FETCH_TICKET_ORDER_BY_EVENT_FINALIZE_DESC = '-event__finalize_ts';
